/**
 * Created by mongoose on 7/11/17.
 */
import React from "react";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import SelectGroup from "./SelectGroup";
import InputGroup from "./InputGroup";
import HiddenGroup from "./HiddenGroup";
import CheckBoxGroup from "./CheckBoxGroup";
import MultiCheckBoxGroup from "./MultiCheckBoxGroup";
import TextAreaGroup from "./TextAreaGroup";
import DatePickerGroup from "./DatePickerGroup";
import TickerPickerGroup from "./TickerPickerGroup";
import NestedEntityGroup from "./NestedEntityGroup";
import DurationGroup from "./DurationGroup";
import asFormField from "./FormFieldHOC";
import DisplayConditionListRenderer from "./DisplayConditionListRenderer";
import SwitchGroup from "./SwitchGroup";
import ImageManager from "./ImageManager";
import ColorView from "./ColorView";
import ColorPicker from "./ColorPicker";
import ContractableConditions from "./Restrictable/ContractableConditions";
import OpenBooking from "./Restrictable/OpenBooking";
import OpenTravel from "./Restrictable/OpenTravel";
import CloseTravel from "./Restrictable/CloseTravel";
import CloseBooking from "./Restrictable/CloseBooking";
import RadioButtonGroup from "./RadioButtonGroup";
import DiscountPeriodicity from "../Promotions/DiscountPeriodicity";
import richHTMLEditorGroup from "./richHTMLEditorGroup";
import SearchableSelector from "./SearchableSelector";
import OneTimePromoCode from "../Promotions/OneTimePromoCode";
import SimpleText from "./SimpleText";
import FieldErrorList from "./FieldErrorList";
import HelpText from "./HelpText";
import AutoCompleteGroup from "./AutoCompleteGroup";
import SmartSelector from "./SmartSelector";
import SmartSelectorList from "./SmartSelectorList";
import PromotionsTypeRenderer from "./PromotionsTypeRenderer";
import AccordionGroup from "./AccordionGroup";
import DualListBoxGroup from "./DualListBoxGroup";
import CancellationRange from "./CancellationRange";
import { DaysRenderer } from "./DaysRendererGroup";
import AutoCompleteGroupMulti from "./AutoCompleteGroupMulti";
import DynamicIconList from "../../../shared/widgets/DynamicIconList/DynamicIcon";
import { defineMessages, FormattedMessage } from "react-intl";

const messages = defineMessages({
  multiple: {
    id: "common.multiple",
    defaultMessage: "Multiple",
  },
});

export function getRenderer({ rendererType, fieldType, customRenderer }) {
  switch (rendererType) {
    case "singleSwitch":
      return SwitchGroup;
    case "selector":
      return SelectGroup;
    case "cancellationRange":
      return CancellationRange;
    case "input":
      return InputGroup;
    case "hidden":
      return HiddenGroup;
    case "checkbox":
      return CheckBoxGroup;
    case "multicheckbox":
      return MultiCheckBoxGroup;
    case "textarea":
      return TextAreaGroup;
    case "richHTMLEditor":
      return richHTMLEditorGroup;
    case "datepicker":
      return DatePickerGroup;
    case "duration":
      return DurationGroup;
    case "durationText":
      return DurationRenderer;
    case "arrayRenderer":
      return ArrayRenderer;
    case "objectRenderer":
      return ObjectRenderer;
    case "daysRenderer":
      return DaysRenderer;
    case "arrayPropertyRenderer":
      return ArrayPropertyRenderer;
    case "tickerpicker":
      return TickerPickerGroup;
    case "nestedEntity":
      return NestedEntityGroup;
    case "displayConditionsRenderer":
      return DisplayConditionListRenderer;
    case "dateRange":
      return DateRangeRenderer;
    case "nestedDateRange":
      return NestedDateRangeRenderer;
    case "smartSelector":
      return SmartSelector;
    case "smartSelectorList":
      return SmartSelectorList;
    case "imageManager":
      return ImageManager;
    case "colorView":
      return ColorView;
    case "colorPicker":
      return ColorPicker;
    case "contractableConditions":
      return ContractableConditions;
    case "openBooking":
      return OpenBooking;
    case "openTravel":
      return OpenTravel;
    case "closeTravel":
      return CloseTravel;
    case "closeBooking":
      return CloseBooking;
    case "radioButtonGroup":
      return RadioButtonGroup;
    case "discountPeriodicity":
      return DiscountPeriodicity;
    case "oneTimePromoCode":
      return OneTimePromoCode;
    case "searchableSelector":
      return SearchableSelector;
    case "dynamicIconSelector":
      return DynamicIconList;
    case "simpleText":
      return SimpleText;
    case "autoComplete":
      return AutoCompleteGroup;
    case "autoCompleteMulti":
      return AutoCompleteGroupMulti;
    case "promotionsType":
      return PromotionsTypeRenderer;
    case "accordion":
      return AccordionGroup;
    case "dualListBox":
      return DualListBoxGroup;
    case "custom":
      return customRenderer;
    default:
      return getTypeDefaultRenderer(fieldType);
  }
}

// TODO: If this returns always the same what's the point?
export function getTypeDefaultRenderer(fieldType) {
  switch (fieldType) {
    case "String":
      return DefaultRenderer;
    case "Enum":
      return DefaultRenderer;
    case "Number":
      return DefaultRenderer;
    case "Boolean":
      return DefaultRenderer;
    default:
      return DefaultRenderer;
  }
}

export function validateParams({ field, entity }) {
  return !(
    !entity ||
    !field ||
    !field.hasOwnProperty("fieldName") ||
    !entity.hasOwnProperty(field.fieldName)
  );
}

export function DurationRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  return (
    <div>
      {entity[field.fieldName].duration} {entity[field.fieldName].chronoUnit}
    </div>
  );
}

/** gets an object, then transform it into an array to make a map and iterate returning the corresponding value*/
export function ObjectRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  return (
    <div>
      {entity[field.fieldName] &&
        Object.values(entity[field.fieldName]).map((value, idx) => {
          return <span key={idx}>{value} </span>;
        })}
    </div>
  );
}

/** gets an array, then iterate returning the corresponding value*/
export function ArrayRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  return (
    <div>
      <span>{entity[field.fieldName].join(", ")}</span>
    </div>
  );
}

// TODO: @angel this is too specific, REFACTOR
/** gets an array and search for the designed property to render it individually*/
export function ArrayPropertyRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  /** this widget need two extra properties in field to work 1:fieldSelector 2:searchCriteria*/
  /** The first is all the options from the selector with the corresponding text, all in form of object*/
  /** The second is the name of the property inside the array to look for and it will only render the first match*/
  const value =
    field.fieldSelector[
      typeof entity[field.fieldName] === "object"
        ? entity[field.fieldName].filter(value => value[field.searchCriteria] !== undefined)[0][
            field.searchCriteria
          ]
        : entity[field.searchCriteria]
    ];
  return (
    <div>
      <span>{value}</span>
    </div>
  );
}

export function DateRangeRenderer({ field, entity, entities, validation }) {
  let startDate = entity[field.startDateProp];
  let endDate = entity[field.endDateProp];

  if ((!startDate || !endDate) && field.getDates) {
    const dates = field.getDates(entity);

    if (typeof dates === "string") {
      return <div>{dates}</div>;
    }

    startDate = dates.startDate;
    endDate = dates.endDate;
  }

  if (!startDate || !endDate) {
    return null;
  }

  if (field.multiLine) {
    return (
      <div>
        <div>{startDate}</div>
        <div>{endDate}</div>
      </div>
    );
  }

  return (
    <div>
      {startDate} - {endDate}
    </div>
  );
}

export function NestedDateRangeRenderer({ field, entity }) {
  let nestedDates = entity[field.nestedFieldName];
  if (nestedDates.length === 1) {
    return (
      <div>
        {nestedDates[0].startDate} - {nestedDates[0].endDate}
      </div>
    );
  }

  if (nestedDates.length > 1) {
    return (
      <div>
        <FormattedMessage {...messages.multiple} />
      </div>
    );
  }

  return null;
}

export function DefaultRenderer({ field, entity, entities, validation }) {
  if (!validateParams({ field, entity, entities, validation })) {
    return null;
  }
  const value = entity[field.fieldName];
  if (Array.isArray(value)) {
    return <div>{value.join(",")}</div>;
  } else if (typeof value === "boolean") {
    return (
      <div>
        {value ? (
          <em
            style={{
              color: "green",
              fontSize: "20px",
            }}
            className="fa fa-check"
          />
        ) : (
          <em
            style={{
              color: "red",
              fontSize: "20px",
            }}
            className="fa fa-minus-circle "
          />
        )}
      </div>
    );
  }
  // Security (CWE-79): never inject persisted values as raw HTML here. This is the
  // fallback renderer for every field that declares no explicit `widget`, so any
  // stored string would otherwise become markup executed in the viewer's session.
  // Render as text instead; React escapes text children natively.
  if (value === null || value === undefined) {
    // Matches the previous behaviour: React skipped dangerouslySetInnerHTML when
    // __html was null/undefined, so nothing was rendered inside the div.
    return <div />;
  }
  // Non-primitive values used to be coerced by the innerHTML assignment. Keep that
  // coercion explicitly: rendering a raw object as a React child would throw.
  return <div>{typeof value === "object" ? String(value) : value}</div>;
}

const StyledInfoIcon = styled.i`
  cursor: pointer;
  margin-left: 5px;
`;

const StyledFieldset = styled.fieldset`
  ${props => (props.caller === "list" ? `margin-bottom: 0; padding-bottom: 0;` : undefined)}
`;

const StyledReactTooltip = styled(ReactTooltip)`
  width: 300px;
`;

const SubtitleText = styled.span`
  margin: 0 0 30px;
  display: block;
  color: #909293;
`;

export const TooltipCustom = ({ text, id }) => (
  <>
    <StyledInfoIcon className="fa fa-info-circle" data-tip="React-tooltip" data-for={id} />
    <StyledReactTooltip place="right" type="dark" effect="solid" id={id}>
      {text}
    </StyledReactTooltip>
  </>
);

function WidgetRenderer({
  rendererType,
  fieldType,
  field,
  entity,
  entities,
  validation,
  formValues,
  errors,
  caller,
  ...props
}) {
  const Renderer = getRenderer({
    rendererType,
    fieldType,
    customRenderer: field.customRenderer,
  });

  const renderer = (
    <Renderer
      field={field}
      entity={entity}
      entities={entities}
      validation={validation}
      formValues={formValues}
      caller={caller}
      {...props}
    />
  );

  switch (rendererType) {
    case "hidden":
      return null;

    case "section":
      return (
        <>
          <legend className={field.className} id={field.menuIndex}>
            {field.displayName}
          </legend>
          {field.subtitle && (
            <SubtitleText className="subtitleSection">{field.subtitle}</SubtitleText>
          )}
        </>
      );

    case "subsection":
      return <h4 className={field.className}>{field.displayName}</h4>;

    default:
      return (
        <StyledFieldset className={field.className} caller={caller}>
          {caller === "form" ? (
            <>
              {field.displayName && (
                <>
                  <label>
                    {field.displayName}
                    {field.required && "*"}
                  </label>
                  {field.tooltip && <TooltipCustom text={field.tooltip} id={field.fieldName} />}
                </>
              )}
              {renderer}
              <FieldErrorList errors={errors} />
              <HelpText text={field.helpText} className={field.helpTextClassName} />
            </>
          ) : (
            renderer
          )}
        </StyledFieldset>
      );
  }
}

export default asFormField(WidgetRenderer);
